export default __webpack_public_path__ + "static/media/vuesax-linear-profile-2user.b09f0861.svg";